import React from "react";

export default (props) => <form onSubmit={props.event}>{props.children}</form>;
